'use client';

import { useTranslation } from 'react-i18next';

/**
 * Content-kind enum → its `microChrome.kind.*` catalogue suffix.
 *
 * <p>Single source for every surface that names a kind — the popup's
 * {@code KindBadge} and the card chip on rails/grids. Before this
 * existed the card printed the raw backend enum (`SCENARIO`,
 * `WEEKLY READ`), which no catalogue could translate.
 */
const KIND_KEY: Record<string, string> = {
  SHORT_VIDEO: 'shortVideo',
  SHORTS: 'shorts',
  QUIZ: 'quiz',
  WEEKLY_READ: 'weeklyRead',
  INTERACTIVE: 'interactive',
  INFO_CARDS: 'infoCards',
  CHECKLIST: 'checklist',
  AUDIO: 'audio',
  DOWNLOAD: 'download',
  SCENARIO: 'scenario',
  LEARNING_PATH: 'learningPath',
  POLL: 'poll',
  BUSINESS_STORY_CARDS: 'storyCards',
};

/**
 * Returns a resolver for localized kind labels. An unknown kind (the
 * backend carries two the portal has no player for) degrades to the
 * de-underscored enum rather than rendering an empty chip.
 */
export function useKindLabel(): (kind: string) => string {
  const { t } = useTranslation('site-builder-blocks');
  return (kind: string) => {
    const key = KIND_KEY[kind];
    return key ? t(`microChrome.kind.${key}`) : kind.replace(/_/g, ' ');
  };
}
